import { SET_USER, SET_USER_FILES } from "../constants";

const INIT_STATE = {
    user: null,
    isAdmin: false,
    isViewer: false,
    isMerchant: false,
    isSupport: false,
    isAuthorized: false,
    isConfirmed: false,
    files: {},
    phonesVisible: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_USER:
            if (!action.user) {
                return { ...INIT_STATE };
            }

            const { user } = action;

            return {
                user: { ...user },
                isAdmin: user.role && user.role === 'admin',
                isViewer: user.role && user.role === 'viewer',
                isMerchant: user.assignProgramIds && user.assignProgramIds.length > 0,
                isJulia: user.login === 'julia@moonbitx.com',
                isSupport: user.isSupport,
                isAuthorized: true,
                isConfirmed: user.confirmed,
                files: { ...state.files },
                phonesVisible: user.phonesVisible,
            };
        case SET_USER_FILES:
            return {
                ...state,
                ...{ files: { ...action.files } }
            };
        default:
            break;
    }
    return state;
};
